var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.374,
    height: 18.374,
    viewBox: "0 0 18.374 18.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.616)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.689,42.549l10.775-10.775,3.475,3.475L157.164,46.024Zm0,0",
    transform: "translate(-143.315 -29.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M130.273,197.681l3.84-1.064-2.777-2.777Zm0,0",
    transform: "translate(-121.657 -179.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M314.5.8a1.847,1.847,0,0,0-2.609,0l-.783.783,3.475,3.475.783-.783a1.847,1.847,0,0,0,0-2.609Zm0,0",
    transform: "translate(-288.913 -0.264)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.e724944fe3bb70ca20a24d2586c0392a.svg";
export { ForwardRef as ReactComponent };